<template>
  <v-container fluid>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-btn color="primary" dark class="mb-2" @click="addHandset">
        New Handset
      </v-btn>
      <v-dialog v-model="dialog" max-width="800px" persistent>
        <v-card>
          <v-card-title class="primary">
            <span class="headline white--text">Edit Hardware</span>
          </v-card-title>
          <v-card-text class="px-4">
            <v-form v-model="valid" lazyValidation>
              <v-container grid-list-md class="custom-margin pa-0">
                <v-layout row wrap>
                  <v-flex xs6>
                    <ValidationProvider
                      name="Model"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="editedItem.model"
                        label="Model"
                        name="model"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <ValidationProvider
                      name="Hardware Category"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        data-vv-as="hardwareCategoryID"
                        name="hardwareCategoryID"
                        v-model="editedItem.hardwareCategoryID"
                        label="Hardware Category"
                        :items="categories"
                        :error-messages="errors"
                        item-text="category"
                        item-value="hardwareCategoryID"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <ValidationProvider
                      name="MIA Internal Item ID"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        name="miaInternalItemId"
                        v-model.number="editedItem.miaInternalItemId"
                        label="MIA Internal Item ID"
                        :items="allStocks"
                        item-text="Store Display Name"
                        item-value="internalID"
                        :error-messages="errors"
                      >
                        <template v-slot:item="{ item }">
                          <span>
                            {{ item['Store Display Name'] }} (sku:{{
                              item.sku
                            }})
                          </span>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <ValidationProvider
                      name="Manufacturer"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        data-vv-as="manufacturerDetailsID"
                        name="manufacturerDetailsID"
                        v-model="editedItem.manufacturerDetailsID"
                        label="Manufacturer"
                        :items="manufacturers"
                        :error-messages="errors"
                        item-text="description"
                        item-value="manufacturerID"
                        @error="manufacturerNotFound"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-0 mb-4">
                    <ValidationProvider name="Free Type Amount (No Freight">
                      <v-checkbox
                        name="freeTypeAmount"
                        v-model="editedItem.freeTypeNoFreight"
                        label="Free Type Amount (No Freight)"
                        hide-details
                        :disabled="editedItem.freeTypeWithFreight"
                      ></v-checkbox>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-0 mb-4">
                    <ValidationProvider name="Free Type Amount (With Freight)">
                      <v-checkbox
                        name="freeTypeAmount"
                        v-model="editedItem.freeTypeWithFreight"
                        label="Free Type Amount (With Freight)"
                        hide-details
                        :disabled="editedItem.freeTypeNoFreight"
                      ></v-checkbox>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12>
                    <ValidationProvider
                      name="Description"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        name="description"
                        v-model="editedItem.description"
                        label="Description"
                        :error-messages="errors"
                      ></v-textarea>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12>
                    <ValidationProvider name="Image Path" v-slot="{ errors }">
                      <v-text-field
                        name="imagePath"
                        v-model="editedItem.imagePath"
                        label="Image Path"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      name="dealerEx"
                      prefix="$"
                      v-model="editedItem.dealerEx"
                      label="Dealer Price (ex)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      name="rrpEx"
                      prefix="$"
                      v-model="editedItem.rrpEx"
                      label="RRP (ex)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      label="Status"
                      :items="statuses"
                      v-model="editedItem.status"
                      item-text="text"
                      item-value="val"
                      browser-autocomplete="disabled"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 class="py-0 mb-4" v-if="allFlags.SOG2985">
                    <ValidationProvider name="Free Type Amount (No Freight">
                      <v-checkbox
                        name="excludedFinance"
                        v-model="editedItem.excludeFinanced"
                        label="Exclude from Grenke financed orders"
                        hide-details
                      ></v-checkbox>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12>
                    <v-tabs color="primary" dark slider-color="primary">
                      <v-tab ripple>Rental</v-tab>
                      <v-tab-item>
                        <v-layout row wrap class="well px-2 pb-2">
                          <v-flex xs12 class="pb-3">
                            <v-checkbox
                              name="rental"
                              v-model="editedItem.rental"
                              label="Hardware Rental"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm5 v-if="!allFlags.SOG8484">
                            <v-text-field
                              name="RentalEx"
                              v-model="editedItem.rentalEx"
                              label="Rental Price (ex)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm7>
                            <v-select
                              multiple
                              label="Available on Plan"
                              :items="ratePlans.filter((x) => x.rentalHardware)"
                              v-model="editedItem.availableOnRatePlans"
                              item-text="ratePlanDescription"
                              item-value="ratePlanID"
                              browser-autocomplete="disabled"
                              clearable
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>
                      <v-tab ripple v-if="!allFlags.SOG8484">Qantas</v-tab>
                      <v-tab-item v-if="!allFlags.SOG8484">
                        <v-layout row wrap class="well">
                          <v-flex xs12 class="pb-3">
                            <v-checkbox
                              name="qantas"
                              v-model="editedItem.qantas"
                              label="Qantas Finance"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm5>
                            <v-text-field
                              name="QantasEx"
                              v-model="editedItem.qantasEx"
                              label="Finace Price (ex)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm7>
                            <v-select
                              multiple
                              label="Available on Plan"
                              :items="ratePlans.filter((x) => x.qantas)"
                              v-model="editedItem.availableOnRatePlans"
                              item-text="ratePlanDescription"
                              item-value="ratePlanID"
                              browser-autocomplete="disabled"
                              clearable
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>
                      <v-tab ripple>Standard</v-tab>
                      <v-tab-item>
                        <v-layout row wrap class="well">
                          <v-flex xs12>
                            <v-autocomplete
                              multiple
                              chips
                              label="Available on Plan"
                              :items="
                                ratePlans.filter(
                                  (x) =>
                                    x.archived == false &&
                                    !x.qantas &&
                                    !x.rental
                                )
                              "
                              v-model="editedItem.availableOnRatePlans"
                              item-text="ratePlanDescription"
                              item-value="ratePlanID"
                              browser-autocomplete="disabled"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>
                      <v-tab ripple>Related Hardware</v-tab>
                      <v-tab-item>
                        <v-layout row wrap class="well pb-2">
                          <v-flex xs12 sm6>
                            <v-autocomplete
                              label="Related Hardware"
                              :items="handsets"
                              v-model="editedItem.relatedHardwareID"
                              :item-text="setText"
                              item-value="handsetID"
                              browser-autocomplete="disabled"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                          <v-text-field
                            name="priceWhenIncluded"
                            prefix="$"
                            v-model="editedItem.priceWhenIncluded"
                            label="Price When Included"
                          ></v-text-field>
                          <v-flex xs12 sm6>
                            <v-checkbox
                              name="include"
                              v-model="editedItem.alwaysInclude"
                              label="Always include"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-checkbox
                              name="hasOverride"
                              v-model="editedItem.hasOverride"
                              label="Override when included"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-tab-item>
                    </v-tabs>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <message-alert :component="message"></message-alert>
          </v-card-text>
          <v-card-actions class="px-0">
            <v-spacer></v-spacer>
            <div class="px-4 pb-3">
              <v-btn
                color="primary"
                :disabled="invalid"
                @click.native="save"
                class="mr-2"
              >
                Save
              </v-btn>
              <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div>
        <v-layout row>
          <v-flex xs4>
            <v-text-field
              name="Search"
              label="Search"
              v-model="SearchText"
              append-icon="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-checkbox
              v-model="showArchived"
              class="mx-3"
              name="showArchived"
              label="Show Archived"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </div>

      <v-data-table
        :total-items="totalItems"
        :pagination.sync="pagination"
        :items="filteredRows"
        :headers="headers"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <td
            v-for="(prop, propIndex) in headers"
            :key="propIndex"
            :class="'ma-0'"
          >
            <div
              v-if="prop.autocomplete && props.item[prop.value][prop.nested]"
              :class="'text-xs-' + prop.align"
            >
              {{ props.item[prop.value][prop.nested] }}
            </div>

            <div v-else :class="'text-xs-' + prop.align">
              {{ props.item[prop.value] }}
            </div>

            <div
              v-if="prop.text == 'Actions'"
              class="justify-center layout px-0"
            >
              <v-btn icon class="mx-0" @click="editItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
      <v-flex sm12 md12 lg12>
        <message-alert :component="message"></message-alert>
      </v-flex>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import {
  mapHandsetFields,
  mapHandsetMultiRowFields,
  mapRatePlanMultiRowFields,
  mapHardwareMultiRowFields,
} from '../store/modules/orders';

const { mapActions: mapHandsetActions, mapMutations: mapHandsetMutations } =
  createNamespacedHelpers(`orders/handset`);
const { mapActions: mapHardwareActions } =
  createNamespacedHelpers(`orders/hardware`);
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
const {
  mapActions: mapRatePlanActions,
} = createNamespacedHelpers(`orders/ratePlan`);
import { httpError } from '../models/httpError';
import { handset } from '../models/handset';

export default {
  name: 'maintainHandsets',
  data: () => ({
    valid: true,
    dialog: false,
    statuses: [
      { val: 'active', text: 'Active' },
      { val: 'archived', text: 'Archived' },
    ],
    editedItem: new handset(),
    editedIndex: 0,
    SearchText: null,
    items: [],
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
    },
    loading: false,
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'handsetID',
      },
      {
        text: 'Model',
        align: 'left',
        sortable: true,
        value: 'model',
      },
      {
        text: 'Mia',
        align: 'left',
        sortable: true,
        value: 'miaInternalItemId',
      },
      {
        text: 'Description',
        align: 'left',
        sortable: true,
        value: 'description',
      },

      {
        text: 'Hardware Category',
        align: 'left',
        sortable: true,
        value: 'hardwareCategory',
        nested: 'category',
        autocomplete: true,
      },

      {
        text: 'Status',
        align: 'left',
        sortable: true,
        value: 'status',
      },
      { text: 'Actions', value: null, sortable: false, fixed: true },
    ],
    showArchived: false,
  }),

  computed: {
    ...mapHandsetFields(['message']),
    ...mapHandsetMultiRowFields(['rows', 'categories', 'manufacturers']),
    ...mapRatePlanMultiRowFields({ ratePlans: 'rows' }),
    ...mapHardwareMultiRowFields(['handsets']),
    ...mapGetters('orders', ['allStocks']),
    ...mapFeatureFlagGetters(['allFlags']),
    filteredRows: function () {
      let vm = this;
      return vm.rows.filter(this.isValid);
    },
    validHandsets() {
      let vm = this;
      return vm.handsets
        .filter((x) => (vm.isRental ? x.rental == vm.isRental : true))
        .sort(function compare(a, b) {
          if (a.manufacturer && a.manufacturer.description) {
            if (
              a.manufacturer.description.toLowerCase() <
              b.manufacturer.description.toLowerCase()
            )
              return -1;
            if (
              a.manufacturer.description.toLowerCase() >
              b.manufacturer.description.toLowerCase()
            )
              return 1;
            return 0;
          }
        });
    },
  },

  mounted() {
    let vm = this;
    vm.getDataFromApi();
    vm.$store.dispatch('orders/hardware/getHandsets');
    vm.getAllStock();
    vm.getRatePlans()
  },
  methods: {
    ...mapOrderActions(['getAllStock']),
    ...mapHandsetActions([
      'getHandsets',
      'saveHandsets',
      'removeHandset',
      'saveHandset',
      'setMessage',
    ]),
    ...mapHandsetMutations(['addRow']),
    ...mapRatePlanActions([
      'getRatePlans',
    ]),
    manufacturerNotFound(val) {},
    addHandset() {
      var vm = this;
      vm.setMessage(new httpError());
      vm.addRow();

      vm.editedIndex = vm.rows.length - 1;
      vm.editedItem = vm.rows[vm.editedIndex];
      vm.dialog = true;
    },
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      vm.getHandsets(vm.showArchived).then(() => {
        let items = vm.rows;
        const total = vm.rows.count;
        vm.loading = false;
      });
    },
    editItem(item) {
      let vm = this;
      vm.setMessage(new httpError());
      vm.editedIndex = this.rows.indexOf(item);
      vm.editedItem = item;

      vm.dialog = true;
    },
    deleteItem(item) {
      var vm = this;
      this.setMessage(new httpError());
      const index = this.rows.indexOf(item);
      let answer = confirm('Are you sure you want to delete this item?');
      if (answer) {
        vm.removeHandset(item)
          .then(() => {
            vm.getDataFromApi();
          })
          .catch(() => {});
      }
    },

    isValid: function (item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter((x) => x.sortable).map((x) => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let vm = this;
      vm.saveHandset(vm.editedIndex)
        .then(() => {
          vm.close();
          vm.getDataFromApi();
        })
        .catch(() => {});
    },

    setText(item) {
      let manufacturer = item.manufacturer ? item.manufacturer.description : '';
      return `${manufacturer} (${item.model})`;
    },
    setInternalId(item) {
      if (
        item['Store Display Name'] !== null &&
        item['Store Display Name'] !== ''
      ) {
        if (item.sku !== null && item.sku !== '')
          return `${item['Store Display Name']} - ${item.sku}`;
        else return `${item['Store Display Name']}`;
      } else if (item.sku !== null && item.sku !== '') return item.sku;
      else return item.name;
    },
  },
  watch: {
    showArchived: function () {
      this.getDataFromApi();
    },
  },
};
</script>

<style lang="scss" scoped>
.well {
  background-color: aliceblue;
}

/* ::v-deep .custom-margin .row .layout:only-child {
  margin: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
} */

.custom-margin {
  ::v-deep .layout:only-child {
    margin: 0px !important;
  }
  ::v-deep .row {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>
